import React, { useState } from 'react';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { logErrorToConsole } from 'src/utils/util';
import { useLocation } from 'react-router-dom';
import { MainSubContainer, MobileHeader, Title } from './index.styled';
import { useSelector, useDispatch } from 'react-redux';
import { setProgressBarStatus } from 'src/pages/consignmentReturn/redux/actions';
import InventoryHeader from './InventoryHeader';
import InventorySearch from './InventorySearch';
import InventoryBody from './InventoryBody';
import InventoryFooter from './InventoryFooter';
import { useHistory } from 'react-router-dom';
import ArrowLeft from 'src/assets/images/ArrowLeftBack.svg';
import { getInventoryDetails } from '../../redux/actions';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { getRoutePathWithParams } from 'src/utils/util';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { pageNames } from 'src/constants/appConstants';

import { useTranslation } from 'react-i18next';
  



const ConsignmentInventory = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const [itemsCheckedCount, setItemCheckedCount] = useState(0);
    const [searchItem, setSearchItem] = useState('');
    const [filterCheckedItems, setFilterCheckedItems] = useState([]);
    const [qtyVal, setQtyVal] = useState(1);
    const [showBtn, setShowBtn] = useState(false);
    const [inputVal, setInputVal] = useState('');
    const [itemsVal, setItemsVal] = useState([]);
    const [checked, setChecked] = useState([]);
    const [valid, setQtyValid] = useState(false);
    const [clrAll, setClrAll] = useState(false);
    const [modifiedData, setModifiedData] = useState([]);
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const [sortOrderName] = useState('ASC');
    const [sortCode, setSortCode] = useState('cfn');
    const [sortParams, setSortParams] = useState('cfn');

    const [pageNo, setPageNo] = useState(0);
    const [sortOrder, setSortOrder] = useState('ASC');

    const onPageChange = (event) => {
        setFirst(event.first);
        setPage(event.page);
        setPageNo(event.pageNo); 
    };
    const accountId = useSelector(
        (state) =>
            state.consignmentReturnReducer.surgeryDetails.accountId.accountId
    );
    const { inventoryData, totalResults, checkedItems, loading , sortParam } = useSelector(
        (state) => state.InventoryReturnReducer
    );
    // const totalResults = useSelector(
    //     (state) => state.InventoryReturnReducer.totalResults
    // );
    // const {
    //     inventoryData,
    //     patientFirstName,
    //     patientLastName,
    //     physicianName,
    //     hrefId,
    // } = useSelector((state) => ({
    //     inventoryData: state.InventoryReturnReducer.inventoryData,
    //     totalResults: state.InventoryReturnReducer.totalResults,
    //     patientLastName:
    //         state.consignmentReturnReducer.surgeryDetails.patientLastName,
    //     physicianName:
    //         state.consignmentReturnReducer.surgeryDetails.physicianId,
    //     hrefId: state.consignmentReturnReducer.surgeryDetails.hrefId,
    // }));
    const { t } = useTranslation();
    useDynatracePageName(pageNames.consigmentReturnInventory);
    useEffectWithErrorLogging(() => {
        const payload = {
            accountNumber: accountId,
            productType: 'tissue',
            orderType: 'ZKA',
            resourceType: 'INVENTORY_LIST',
            sortCode: sortCode,
            sortOrder: sortOrderName,
            currentPage: page,
            pageSize: '50',
            checkedItems: checkedItems,
            searchQuery: searchItem,
            filterParam: 'all',
        };
        dispatch(getInventoryDetails(payload));
    }, [location, page, sortOrderName, sortCode]);



    const sortChangeHandler = (sortParamsValue,sortOrderValue) => {
        let sortCodeAPI = '';
        let sortOrderAPI  = '';
        if(sortParamsValue !== sortParams){
            setSortParams(sortParamsValue);
            setSortOrder('ASC');
            sortCodeAPI = sortParamsValue;
            sortOrderAPI='ASC';
        }else{

            setSortOrder(sortOrderValue === 'ASC' ? 'DESC': 'ASC');
            sortCodeAPI = sortParams;
            sortOrderAPI= sortOrderValue === 'ASC' ? 'DESC': 'ASC';
        }

        const payload = {
            accountNumber: accountId,
            productType: 'tissue',
            orderType: 'KE',
            resourceType: 'INVENTORY_LIST',
            sortCode: sortCodeAPI,
            sortOrder: sortOrderAPI,
            currentPage: pageNo,
            pageSize: '50',
            filterParam: 'all',
            searchQuery: searchItem,
        };
        dispatch(getInventoryDetails(payload));
    };

    return (
        <>
         {loading && (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner id="consignmentReturn-inventory-inventory-loadingSpinner" animation="border" variant="primary" small />
                </Backdrop>
            )}
            <MobileHeader>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: '16px',
                    }}
                >
                    <img
                        id={`back-arrow-${accountId || 'unknown'}`}
                        src={ArrowLeft}
                        alt="back"
                        onClick={() => {
                            try {
                                history.push(getRoutePathWithParams('/consignmentReturn'));
                                dispatch(setProgressBarStatus('Account'));
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        style={{
                            height: '18px',
                            width: '11px',
                        }}
                    />
                </div>
                <Title>{t('consignmentReturn.billing.addFromInventory')} </Title>
            </MobileHeader>
            <MainSubContainer smalDeviceMargin={'91%'}>
                <InventoryHeader />
                <InventorySearch
                    setSearchItem={setSearchItem}
                    setShowBtn={setShowBtn}
                    filterCheckedItems={filterCheckedItems}
                    checked={checked}
                    setChecked={setChecked}
                    setFilterCheckedItems={setFilterCheckedItems}
                    itemsCheckedCount={itemsCheckedCount}
                    setItemCheckedCount={setItemCheckedCount}
                    setClearAll={(value) => {
                    }}
                    itemsVal={itemsVal}
                    setItemsVal={setItemsVal}
                    setModifiedData={setModifiedData}
                    searchItem={searchItem}
                />

                <InventoryBody
                    inventoryDetails={
                        modifiedData.length > 0 ? modifiedData : inventoryData
                    }
                    setItemCheckedCount={setItemCheckedCount}
                    setFilterCheckedItems={setFilterCheckedItems}
                    setQtyVal={setQtyVal}
                    qtyVal={qtyVal}
                    setInputValue={(value) => {
                        setInputVal(value);
                    }}
                    setItemsVal={(value) => setItemsVal(value)}
                    filterCheckedItems={filterCheckedItems}
                    checked={checked}
                    setChecked={setChecked}
                    itemsVal={itemsVal}
                    setValid={(valid) => {
                        setQtyValid(valid);
                    }}
                    clrAll={clrAll}
                    setSortCode={setSortCode}
                    sortCode={sortCode}
                    sortParam={sortParam}
                    sortOrder={sortOrder}
                    setSortOrder={setSortOrder}
                    sortParams={sortParams}
                    setSortParams={setSortParams}
                    sortChangeHandler={sortChangeHandler}
                />
            </MainSubContainer>
            <InventoryFooter
                itemsCheckedCount={itemsCheckedCount}
                inventoryDetails={inventoryData}
                filterCheckedItems={filterCheckedItems}
                qtyVal={qtyVal}
                inputVal={inputVal}
                showBtn={showBtn}
                itemsVal={itemsVal}
                valid={valid}
                totalResults={totalResults}
                onPageChange={onPageChange}
                page={page}
                setPage={setPage}
                first={first}
                setFirst={setFirst}
                checked={checked}
                searchItem={searchItem}
            />
        </>
    );
};

export default ConsignmentInventory;
